import React, { useState } from "react";
import {
  Chip,
  Divider,
  Grid,
  Button,
  TextField,
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Typography,
  Select,
  MenuItem,
  Link,
} from "@mui/material";
import { useFormik } from "formik";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Auth, Amplify } from "aws-amplify";
import "./SignUp.css";
import awsmobile from "../aws-exports";
import { signUpValidationSchema } from "../formValidation";

Amplify.configure(awsmobile);

function SignUp(props) {
  const signUpStateEnum = {
    SIGN_UP: 0,
    SIGN_IN: 1,
    SIGNED_IN: 2,
    CONFIRM: 3,
    FORGOTTEN: 4,
    RESET: 5,
  };

  const [signUpNavigator, setSignUpNavigator] = React.useState(
    signUpStateEnum.SIGN_UP
  );

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState({
    password: null,
    confirmPassword: null,
    showPassword: false,
    showConfirmPassword: false,
    error: null,
  });

  const [givenName, setGivenName] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");

  const createCognitoAccount = async (
    user,
    pass,
    phone,
    firstName,
    lastName,
    title
  ) => {
    try {
      const signUpResponse = await Auth.signUp({
        username: user,
        password: pass,
        attributes: {
          given_name: firstName,
          family_name: lastName,
          phone_number: phone,
          "custom:title": title,
        },
      });
      console.log(signUpResponse);
      setSignUpNavigator(signUpStateEnum.CONFIRM);
    } catch (error) {
      console.error(error);
      if (error.code === "UsernameExistsException") {
        setEmailError("Account with email already exists!");
      }
    }
  };

  const confirmCognitoSignUp = async (event) => {
    try {
      await Auth.confirmSignUp(email, confirmationCode);
      // console.log("Confirmed code");
      signInToCognitoAccount();
    } catch (error) {
      console.error(error);
    }
  };

  const signInToCognitoAccount = async (event) => {
    let newUser = { ...props.personalState.user };
    try {
      let user = await Auth.signIn(email, password.password);
      // console.log(user);
      let attributes = await Auth.userAttributes(user);
      newUser.user = attributes;
      console.log(attributes);
      props.personalState.setUser(newUser);
      props.setCafState((cafState) => ({
        ...props.cafState,
        contact1_title: attributes[0].Value,
        contact1_first_name: attributes[5].Value,
        contact1_last_name: attributes[6].Value,
        contact1_mobile_no: attributes[4].Value,
        contact1_email_address: attributes[7].Value,
        email_address: attributes[7].Value,
      }));
      props.activeStepState.setActiveStep(1);
    } catch (error) {
      console.error(error);
      if (error.code === "UserNotConfirmedException") {
        let resend = await Auth.resendSignUp(email);
        console.log(resend);
        setSignUpNavigator(signUpStateEnum.CONFIRM);
      } else if (error.code === "NotAuthorizedException") {
        // setEmailError("Account with email does not exist.");
        setEmailError("Email and password combination does not match.");
      }
    }
  };

  const handleForgotCognitoPassword = async () => {
    try {
      await Auth.forgotPassword(email);
      setSignUpNavigator(signUpStateEnum.RESET);
    } catch (error) {
      console.error("email not found ", error);
    }
  };

  const resetCognitoPassword = async () => {
    try {
      await Auth.forgotPasswordSubmit(
        email,
        confirmationCode,
        password.password
      );
      setSignUpNavigator(signUpStateEnum.SIGN_IN);
    } catch (error) {
      console.error("incorrect code", error);
    }
  };

  const signOutOfCognitoAccount = async (event) => {
    try {
      await Auth.signOut();
      setSignUpNavigator(signUpStateEnum.SIGN_IN);
    } catch (error) {
      console.error("error signing out: ", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      givenName: "",
      familyName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone: "",
    },
    validationSchema: signUpValidationSchema,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: (values) => {
      console.log("ksajdaskdjkajsdkjaskdjaskdjaksdkjaskdjask");
      setEmailError("");
      if (signUpNavigator === signUpStateEnum.SIGN_UP) {
        setGivenName(values.givenName);
        setEmail(values.email);
        setPassword({ ...password, password: values.password });

        values.phone.replace(/\s/g, "");
        if (!values.phone.startsWith("+61")) {
          values.phone = "+61" + values.phone.substring(1);
          // console.log(values.phone);
        }

        createCognitoAccount(
          values.email,
          values.password,
          values.phone,
          values.givenName,
          values.familyName,
          values.title
        );
      }
    },
  });

  const handleSignUpStateChange = (changeTo) => {
    setSignUpNavigator(changeTo);
  };

  const handleTitleChange = (event) => {
    let newIdentity = {
      ...props.personalState.user.identity,
      title: event.target.value,
    };
    let newUser = { ...props.personalState.user, identity: newIdentity };
    let cafState = { ...props.cafState, contact1_title: event.target.value };
    props.personalState.setUser(newUser);
    props.setCafState(cafState);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleShowPassword = (field) => {
    if (field === "password") {
      setPassword({
        ...password,
        showPassword: !password.showPassword,
      });
    } else if (field === "confirmPassword") {
      setPassword({
        ...password,
        showConfirmPassword: !password.showConfirmPassword,
      });
    }
  };

  const handlePasswordChange = (event, field) => {
    if (field === "password") {
      setPassword({
        ...password,
        password: event.target.value,
      });
    } else if (field === "confirmPassword") {
      setPassword({
        ...password,
        showConfirmPassword: event.target.value,
      });
    }
  };

  const handleConfirmationCodeChange = (event) => {
    setConfirmationCode(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  return (
    <>
      {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
      {signUpNavigator === signUpStateEnum.SIGN_UP ? (
        <form onSubmit={formik.handleSubmit} name="signUpForm" id="SignUpForm">
          <Box sx={{ my: 2 }}>
            <Typography variant="subtitle1" sx={{ m: 1 }}>
              Sign up for an iO Energy Customer Portal Account
            </Typography>
            <Grid container my={1} spacing={1} justifyContent={"space-between"}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <FormControl fullWidth>
                  <InputLabel
                    id="title-label"
                    error={formik.touched.title && Boolean(formik.errors.title)}
                  >
                    Title
                  </InputLabel>
                  <Select
                    id="title"
                    name="title"
                    data-cy="signup-title"
                    value={formik.values.title}
                    label="Title"
                    onChange={(e) => {
                      handleTitleChange(e);
                      formik.handleChange(e);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.title && Boolean(formik.errors.title)}
                  >
                    <MenuItem value={"MR"}>Mr</MenuItem>
                    <MenuItem value={"MRS"}>Mrs</MenuItem>
                    <MenuItem value={"MS"}>Ms</MenuItem>
                    <MenuItem value={"MISS"}>Miss</MenuItem>
                    <MenuItem value={"DR"}>Dr</MenuItem>
                    <MenuItem value={"I'd prefer not to say"}>
                      I'd prefer not to say
                    </MenuItem>
                  </Select>
                  <FormHelperText
                    hidden={
                      !(formik.touched.title && Boolean(formik.errors.title))
                    }
                    error
                  >
                    {formik.errors.title}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                <TextField
                  fullWidth
                  id="givenName"
                  name="givenName"
                  label="First Name"
                  data-cy="signup-first-name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.givenName}
                  error={
                    formik.touched.givenName && Boolean(formik.errors.givenName)
                  }
                  helperText={
                    formik.touched.givenName && formik.errors.givenName
                  }
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                <TextField
                  fullWidth
                  id="familyName"
                  name="familyName"
                  label="Surname"
                  data-cy="signup-last-name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.familyName}
                  error={
                    formik.touched.familyName &&
                    Boolean(formik.errors.familyName)
                  }
                  helperText={
                    formik.touched.familyName && formik.errors.familyName
                  }
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  data-cy="signup-email"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={(e) => {
                    formik.handleBlur(e);
                    setEmailError("");
                  }}
                  value={formik.values.email}
                  error={
                    (formik.touched.email && Boolean(formik.errors.email)) ||
                    (Boolean(emailError) && formik.touched.email)
                  }
                  helperText={
                    emailError
                      ? emailError
                      : formik.touched.email && formik.errors.email
                  }
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="phone"
                  data-cy="signup-phone-number"
                  name="phone"
                  label="Phone"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  helperText={formik.touched.phone && formik.errors.phone}
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    id="password"
                    name="password"
                    data-cy="signup-password"
                    type={password.showPassword ? "text" : "password"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                    fullWidth
                    label="Password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => handleShowPassword("password")}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {password.showPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    id="confirmPassword"
                    name="confirmPassword"
                    data-cy="signup-confirm-password"
                    type={password.showConfirmPassword ? "text" : "password"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmPassword}
                    error={
                      formik.touched.confirmPassword &&
                      Boolean(formik.errors.confirmPassword)
                    }
                    helperText={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    }
                    fullWidth
                    label="Confirm Password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              handleShowPassword("confirmPassword")
                            }
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {password.showPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container justify="center">
              <Button
                variant="contained"
                sx={{ mx: "auto", my: 2 }}
                type="submit"
                data-cy="signup-button"
              >
                <b>Next</b>
              </Button>
            </Grid>
          </Box>
        </form>
      ) : null}
      {signUpNavigator === signUpStateEnum.CONFIRM ? (
        <form name="confirm">
          <FormControl>
            <Typography variant="h5">
              We have sent you an email with a confirmation code.
            </Typography>
            <TextField
              label="Code"
              type="text"
              sx={{ m: 1, display: "block" }}
              fullWidth
              onChange={(e) => {
                handleConfirmationCodeChange(e);
              }}
              onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
            />
            <Typography variant="subtitle">
              Please enter your verification code.
            </Typography>
            <Button
              variant="contained"
              sx={{ mx: "auto", my: 2 }}
              onClick={() => confirmCognitoSignUp()}
            >
              <b>Submit</b>
            </Button>
          </FormControl>
        </form>
      ) : signUpNavigator === signUpStateEnum.SIGNED_IN ? (
        <Box sx={{ display: "block" }}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item sx={{ flexGrow: 1, my: 3, mx: 1 }}>
              <Typography gutterBottom variant="h4">
                {"Welcome " + givenName}
                <span
                  style={{
                    color: "#FF127F",
                    fontSize: "30px",
                  }}
                >
                  .
                </span>
              </Typography>
            </Grid>
            <Grid item mx={"auto"}>
              <Button
                sx={{ float: "right" }}
                onClick={() => signOutOfCognitoAccount()}
              >
                Log Out
              </Button>
            </Grid>
          </Grid>
        </Box>
      ) : null}
      {signUpNavigator === signUpStateEnum.SIGN_UP ? (
        <Divider>
          <Chip label="Or"></Chip>
        </Divider>
      ) : null}
      {signUpNavigator === signUpStateEnum.SIGN_UP ? (
        <Grid container justify="center">
          {/* <Typography variant="subtitle1" sx={{ m: 1 }}>
            Sign up for an iO Energy Customer Portal Account
          </Typography> */}
          <Button
            variant="outlined"
            sx={{ mx: "auto", my: 3, mb: 2 }}
            onClick={() => handleSignUpStateChange(signUpStateEnum.SIGN_IN)}
            data-cy="sign-in-to-account-button"
          >
            SIGN IN TO AN EXISTING ACCOUNT
          </Button>
        </Grid>
      ) : signUpNavigator === signUpStateEnum.SIGN_IN ? (
        <form name="signIn">
          <TextField
            label="Email"
            id="email"
            type="email"
            sx={{ my: 1, display: "block" }}
            fullWidth
            onChange={(e) => handleEmailChange(e)}
            error={Boolean(emailError)}
            helperText={emailError ? emailError : null}
            data-cy="email"
            onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
          />
          <FormControl
            sx={{ my: 1, display: "block" }}
            fullWidth
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              data-cy="outlined-adornment-password"
              type={password.showPassword ? "text" : "password"}
              value={password.password || ""}
              onChange={(e) => handlePasswordChange(e, "password")}
              fullWidth
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleShowPassword("password")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {password.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>

          <Grid item container my={3} justifyContent={"center"}>
            <Button
              variant="contained"
              data-cy="sign-in-button"
              onClick={(e) => {
                signInToCognitoAccount(e);
                setEmailError("");
              }}
            >
              <b>Sign In</b>
            </Button>
          </Grid>
          <Grid item container my={3} justifyContent={"center"}>
            <Link
              href="#"
              variant="body2"
              onClick={() => {
                setEmail("");
                setPassword({ ...password, password: "" });
                setSignUpNavigator(signUpStateEnum.FORGOTTEN);
              }}
            >
              Forgotten password? Click here to reset
            </Link>
          </Grid>
        </form>
      ) : signUpNavigator === signUpStateEnum.FORGOTTEN ? (
        <form name="forgot">
          <FormControl>
            <Typography variant="body">
              It happens! Enter your email below and we will send you a reset
              code.
            </Typography>
            <TextField
              label="Email"
              type="text"
              sx={{ m: 1, display: "block" }}
              fullWidth
              onChange={(e) => {
                handleEmailChange(e);
              }}
              onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
            />
            <Button
              variant="outlined"
              sx={{ mx: "auto", my: 2 }}
              onClick={() => handleForgotCognitoPassword()}
            >
              <b>Email me a reset code</b>
            </Button>
          </FormControl>
        </form>
      ) : signUpNavigator === signUpStateEnum.RESET ? (
        <form name="reset">
          <Typography variant="body">
            Enter your reset code you reveived via email.
          </Typography>
          <TextField
            label="Code"
            type="text"
            sx={{ m: 1, display: "block" }}
            fullWidth
            onChange={(e) => {
              handleConfirmationCodeChange(e);
            }}
            onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
          />
          <Typography variant="body">Enter a new password.</Typography>
          <FormControl
            sx={{ m: 1, display: "block" }}
            fullWidth
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              data-cy="outlined-adornment-password"
              type={password.showPassword ? "text" : "password"}
              value={password.password || ""}
              onChange={(e) => handlePasswordChange(e, "password")}
              fullWidth
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleShowPassword("password")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {password.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>
          <Button
            variant="contained"
            sx={{ mx: "auto", my: 2 }}
            onClick={() => resetCognitoPassword()}
          >
            <b>Reset</b>
          </Button>
        </form>
      ) : null}
    </>
  );
}

export default SignUp;
